import getSelectedSaveView from './getSelectedSaveView';

export default function hasSelectedSaveView(): boolean {
    return !!getSelectedSaveView();
}
